/* eslint-disable jsx-a11y/anchor-is-valid */
import {yupResolver} from '@hookform/resolvers/yup'
import moment from 'moment'
import {FC, useEffect, useMemo, useState} from 'react'
import {FormProvider, useForm} from 'react-hook-form'
import {Column} from 'react-table'
import {KTCard} from '../../../../../../../../_metronic/helpers'
import {KTable, KTableHeader, KTableLoading} from '../../../../../../components/UI'
import {Button, ButtonWrapper} from '../../../../../../components/UI/Button'
import {InputDate} from '../../../../../../components/UI/Input'
import {Select} from '../../../../../../components/UI/Select'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {useKhipu} from '../../../../../../hooks/useKhipu'
import {checkInListSchema} from '../../../../../../util/validationHoteleria'
import {useCentralServices} from '../../../../hooks/useCentralServices'
import {FilterBookingModel, PersonListModel} from '../../model'
import {
  getOpaListGuestService,
  getListPersonExcelService,
} from '../../service/bookingInt'
import {getGuestsService} from '../../../../../hoteleria/services/guest.service'
import {formatDateDDMMYYYY} from '../../../../../../util/dates'
import { SelectAsyncWrapper } from '../../../../../../components/UI/Form/Input'

interface SelectOption {
  value: string | number | undefined
  label: string | undefined
}

const TablePerson: FC = () => {
  const {data, setData, setPagination, loading, setLoading, pagination} = useKTable()
  const methods = useForm<FilterBookingModel>({
    resolver: yupResolver(checkInListSchema),
  })
  const {
    control,
    formState: {errors},
    register,
    setValue,
    handleSubmit,
    setError,
    reset,
    watch
  } = methods
  const {clearSearchValues, searchValues} = useKhipu()
  const [formValue, setFormValue] = useState<any>(null)
  const [formValueLoading, setFormValueLoading] = useState<any>(false)

  const [compani, setCompany] = useState<SelectOption[]>([{value: '', label: 'TODOS'}])
  const [client, setClient] = useState<SelectOption[]>([{value: '', label: 'TODOS'}])
  const [site, setSite] = useState<SelectOption[]>([{value: '', label: 'TODOS'}])
  const [camp, setCamp] = useState<SelectOption[]>([{value: '', label: 'TODOS'}])
  const [loadingExport, setLoadingExport] = useState<boolean>(false)
  const {getCompanies, getClients, getSites, getCamps} = useCentralServices()

  const getCompaniesFn = async () => {
    const data = await getCompanies({isCombo: true}, 1)
    if (data.length === 1) {
      setValue('companiaId', data[0].value as string)
      setError('companiaId', {})
      await getClientsFn(data[0].value as string)
    }
    const allData = [{value: '', label: 'TODOS'}, ...data]
    setCompany(allData)
  }

  const getClientsFn = async (companyId: string) => {
    const data = await getClients({isCombo: true, companiaId: companyId}, 1)
    if (data.length === 1) {
      setValue('clienteId', data[0].value as string)
      setError('clienteId', {})
      await getSitesFn(data[0].value as string)
    }
    const allData = [{value: '', label: 'TODOS'}, ...data]
    setClient(allData)
  }

  const getSitesFn = async (clientId: string) => {
    const data = await getSites({isCombo: true, clienteId: clientId}, 1)
    if (data.length === 1) {
      setValue('siteId', data[0].value as string)
      setError('siteId', {})
      await getCampsFn(data[0].value as string)
    }
    const allData = [{value: '', label: 'TODOS'}, ...data]
    setSite(allData)
    clearInformationGuest()
  }

  const getCampsFn = async (siteId: string) => {
    const data = await getCamps({isCombo: true, siteId: siteId}, 1)
    if (data.length === 1) {
      setValue('campamentoId', data[0].value as string)
      setError('campamentoId', {})
    }
    const allData = [{value: '', label: 'TODOS'}, ...data]
    setCamp(allData)
    clearInformationGuest()
  }

  const getInformationGuest = async (e: any) => {
    let value = e ? e : ''
    setValue('HuespedId', value.value)
    setValue('HuespedDescripcion', value.label)
  }

  const clearInformationGuest =()=>{
    setValue('HuespedId', '')
    setValue('HuespedDescripcion', '')
  }

  const loadOptionsGuest = async (inputValue: string, callback: (options: any[]) => void) => {
    try {
      if (inputValue.length < 3) { return [] }
      const request = {
        CompaniaId: watch('companiaId'),
        ClienteId: watch('clienteId'),
        SiteId: watch('siteId'),
        CampamentoId: watch('campamentoId'),
        BuscaTexto: inputValue,
        pageNumber: 1,
        size: 100,
      }
      const response = await getGuestsService(request)
      const data = response.data.data
      const mappedGuest = data?.map((item: any) => ({
        value: item.Id,
        label: item.Nombres + ' ' + item.ApellidoPaterno + ' ' + item.ApellidoMaterno + ' ' + item.NumeroDocumento,
        ...item,
      }))
      return mappedGuest
    } catch (error) {
      console.error('Error fetching options:', error)
      return []
    }
  }

  const getChekings = async () => {
    try {
      if (!formValue) return
      setLoading(true)
      let obj = {...formValue}
      const {data: response} = await getOpaListGuestService(obj, pagination.currentPage)
      if (!response.error) {
        const temp: {[key: string]: any}[] = []
        response.data.forEach((item: any) => {
          const newItem: {[key: string]: any} = {}
          for (let key in item) {
            newItem[key] = item[key] === null ? '-' : item[key]
          }
          temp.push(newItem)
        })
        setData(temp)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  const handleFilterClient = (e: any) => {
    let value = e.value
    setValue('clienteId', '')
    setValue('siteId', '')
    setValue('campamentoId', '')
    getClientsFn(value)
    setValue('companiaId', value)
    setError('companiaId', {})
    setClient([])
  }

  const handleFilterSite = (e: any) => {
    let value = e.value
    setValue('siteId', '')
    setValue('campamentoId', '')
    getSitesFn(value)
    setValue('clienteId', value)
    setError('clienteId', {})
  }

  const handleFilterCamp = (e: any) => {
    let value = e.value
    setValue('campamentoId', '')
    getCampsFn(value)
    setValue('siteId', value)
    setError('siteId', {})
  }
  const handleFilterGuest = (e: any) => {
    let value = e.value
    setValue('campamentoId', value)
    setError('campamentoId', {})
    clearInformationGuest()
  }

  useEffect(() => {
    getChekings()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  const columns: Column<PersonListModel>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} title='Cliente' />,
        accessor: 'cliente',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Site' />,
        accessor: 'site',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Campamento' />,
        accessor: 'campamento',
      },      {
        Header: (props) => <KTableHeader tableProps={props} title='RUC Contratista' />,
        accessor: 'rucContratista',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Empresa Contratista' />,
        accessor: 'empresaContratista',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='RUC Subcontratista' />,
        accessor: 'rucSubcontratista',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Empresa Subcontratista' />,
        accessor: 'empresaSubcontratista',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Tipo de Documento' />,
        accessor: 'tipoDoc',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nro de documento'
            name='nroDocumento'
            searcheable
            number
          />
        ),
        accessor: 'nroDoc',
      },
      // { Header: (props) => <KTableHeader tableProps={props} title='Nro de Documento' />, accessor: 'nroDoc', },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Huésped' />,
        accessor: 'huesped',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Tip. de Huésped' />,
        accessor: 'tipoHuesped',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Tip. de Estadía' />,
        accessor: 'tipoEstadia',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Estado' />,
        accessor: 'estado',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Módulo' />,
        accessor: 'modulo',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Habitación' />,
        accessor: 'habitacion',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Cama' />,
        accessor: 'cama',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Fecha de Creación de Dato'
            name='fechaCreacionDatos'
            dateable
          />
        ),
        accessor: 'fechaCreacionDatos',
        Cell: ({...props}) => (
          <div>{formatDateDDMMYYYY(props.row.original.fechaCreacionDatos)}</div>
        ),
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Fecha de Última modificación'
            name='fechaModificacion'
            dateable
          />
        ),
        accessor: 'fechaModificacion',
        Cell: ({...props}) => (
          <div>{formatDateDDMMYYYY(props.row.original.fechaModificacion)}</div>
        ),
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Fecha Programada de Ingreso' />,
        accessor: 'fechaTentativaIngreso',
        Cell: ({...props}) => (
          <div>{formatDateDDMMYYYY(props.row.original.fechaTentativaIngreso)}</div>
        ),
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Fecha Programada de Salida' />,
        accessor: 'fechaProgramadaSalida',
        Cell: ({...props}) => (
          <div>{formatDateDDMMYYYY(props.row.original.fechaProgramadaSalida)}</div>
        ),
      },
    ],
    [],
  )

  useEffect(() => {
    getCompaniesFn()

    return () => {
      clearSearchValues()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])
  useEffect(() => {
    if (formValueLoading) {
      setFormValueLoading(false)
      getChekings()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formValueLoading])

  const handleClear = () => {
    clearSearchValues()
    setClient([{value: '', label: 'TODOS'}])
    setSite([{value: '', label: 'TODOS'}])
    setCamp([{value: '', label: 'TODOS'}])
    reset()
    setFormValue(null)
    setData([])
    clearInformationGuest()
  }

  const handleExport = async () => {
    try {
      setLoadingExport(true)
      const response = await getListPersonExcelService({
        ...formValue,
      })
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      moment().format('DD/MM/YY HH:mm').toString()
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `Lista-Personas-${moment().format('DD/MM/YY HH:mm').toString()}.xlsx`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      setLoadingExport(false)
    } catch (error) {
      setLoadingExport(false)
    }
  }

  const onSubmit = (dataForm: FilterBookingModel) => {
    const search = {
      ...dataForm,
      fechaCreacion: searchValues.fechaCreacionDatos,
      fechaModificacion: searchValues.fechaModificacion,
      nroDocumento: searchValues.nroDocumento
    }
    setPagination({
      ...pagination,
      currentPage: 1,
      perPage: 10,
      totalResults: 0,
    })
    setFormValue(search)
    setFormValueLoading(true)
  }

  return (
    <KTCard shadow className='m-5'>
      <FormProvider {...methods}>
        <form className='m-2'>
          <div className='row'>
            <div className='col-sm-12 col-lg-3'>
              <label className='required'>Compañía:</label>
              <Select
                control={control}
                name='companiaId'
                data={compani}
                errors={errors}
                onChangeValue={handleFilterClient}
              />
            </div>
            <div className='col-sm-12 col-lg-3'>
              <label className='required'>Cliente:</label>
              <Select
                control={control}
                name='clienteId'
                data={client}
                errors={errors}
                onChangeValue={handleFilterSite}
              />
            </div>
            <div className='col-sm-12 col-lg-3'>
              <label className='required'>Site:</label>
              <Select
                control={control}
                name='siteId'
                data={site}
                errors={errors}
                onChangeValue={handleFilterCamp}
              />
            </div>
            <div className='col-sm-12 col-lg-3'>
              <label className='required'>Campamento:</label>
              <Select
                control={control}
                name='campamentoId'
                data={camp}
                errors={errors}
                onChangeValue={handleFilterGuest}
              />
            </div>
            <div className='col-sm-12 col-lg-3'>
              <SelectAsyncWrapper
                labelText='Huésped'
                keySelect={`${watch('siteId')}-${watch('campamentoId')}`}
                name='HuespedId'
                loadOptions={loadOptionsGuest}
                onChangeValue={getInformationGuest}
                value={{
                  value: watch('HuespedId') || '',
                  label: watch('HuespedDescripcion') || '',
                }}
                /*errors={errors}*/
              />
            </div>
            <div className='col-sm-12 col-lg-3'>
              <label>Fecha de Creación de Datos:</label>
              <InputDate name='fechaInicio' register={register} errors={errors} />
            </div>
            <div className='col-sm-12 col-lg-3'>
              <label>Fecha Fin de Creación de Datos:</label>
              <InputDate name='fechaFin' register={register} errors={errors} />
            </div>
          </div>
        </form>
        <ButtonWrapper className={'sdx-white-bg'}>
          <Button label='Buscar' onClick={handleSubmit(onSubmit)} />
          <Button label='Limpiar' onClick={handleClear} />
          <Button
            label='Exportar'
            onClick={handleExport}
            disabled={data.length < 1}
            loading={loadingExport}
          />
        </ButtonWrapper>
      {loading ? <KTableLoading title='Cargando...' /> : null}
      <KTable data={data} columns={columns} showButtons={false} clearFilters />
      </FormProvider>
    </KTCard>
  )
}

const TablePersonWrapper = () => {
  return (
    <KTableProvider>
      <TablePerson />
    </KTableProvider>
  )
}

export {TablePersonWrapper}
